import { AxiosRequestConfig } from "axios";

import { ApiError, GeoFenceLocation, Variable } from "@/types";
import { fetchData } from "@/utils";

type GetVariablesApiResponse = {
  data: Variable[];
  error: ApiError | null;
};

export const getVariables = async (
  accessToken: string,
  client: string
): Promise<GetVariablesApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/tags?client=${client}`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};

type GetLocationsApiResponse = {
  data: GeoFenceLocation[];
  error: ApiError | null;
};

export const getLocations = async (
  accessToken: string
): Promise<GetLocationsApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/locations`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};

type SearchVariablesApiResponse = {
  data: Variable[];
  error: ApiError | null;
};

export const searchVariables = async (
  accessToken: string,
  query: string,
  client: string
): Promise<SearchVariablesApiResponse> => {
  const url = `${
    process.env.REACT_APP_API_URL
  }/v2/search?search_term=${encodeURIComponent(query)}&client=${client}`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};
